// Copyright (c) 2024 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import 'react-toastify/dist/ReactToastify.css'
import { downloadTicket, getOfflineTicketDetailsQR, getTicketDetails } from '../../redux/actions/userDetails'
// import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment'
// import {formattedExpiry, getCardIcon, phoneMasker} from '../../utils/helper'
import { QRCodeSVG } from 'qrcode.react'
import { useNavigate, useParams } from 'react-router-dom'
import Loader from '../../global/Loader'
import NoData from '../../components/NoData'
import Footer from '../../components/global/Footer'
import MiniHeader from '../../components/global/MiniHeader'
import { errorMessage } from '../../constants/errorMessage'
import getConfigDetails from '../../services/config'
import { endParking } from '../../redux/actions/transientAction'
import { Circles } from 'react-loader-spinner'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
// import thankyou from '../../assets/img/thank-you-icon.svg'
import {
	formattedExpiry, getLocation, getTotalOverstayPaidAmount, getTotalTimeDuration, isCheckoutButton, isExtendButton, isParksfo, isPermissionExist, isPromoValidateButton, loggedInUserData, phoneMasker,
	sortPortalPermissionByKey,
	// priceGreaterOrNot
} from '../../utils/helper'
import direction from '../../assets/img/traffic-sign.png'
import PaymentBreakUpDetails from '../../components/global/PaymentBreakUpDetails'

// import DownloadApp from '../../components/global/DownloadApp'
import PromptNumberUpdate from '../../global/PromptUpdateNumber'
import { getExtendList } from '../../redux/actions/ExtendFromAction'
import { getBreakUpDetails } from '../../utils/helper'
import URL from '../../constants/urls'
import { useQueryParams } from '../../Hooks/usequeryParamHook'
import { addEventLog } from '../../redux/actions/EventsLog'
import CONSTANTS from '../../redux/constants'
import Promocode from '../../components/global/Promocode'
import PassWalletButtons from '../../components/global/PassWalletButton'
import { Container } from 'react-bootstrap'
import HeroIcon from '../../components/global/heroIcon.svg'

function Ticket(props) {
	const navigate = useNavigate()
	const { dispatch, ticketDetailsFromProps, loader, isFetching, notify, loaderDownload, isFetchingPartner, partnerDetails, isEvent } = props
	const [ticketDetails, setTicketDetails] = useState(EMPTY_OBJECT)
	const [error, setError] = useState('')
	const [isDisplayDetails, setIsDisplayDetails] = useState(true)

	const [isPromptOpen, setPromptNumber] = useState(false)
	const [isNumberUpdated, setIsNumberUpdated] = useState(false)
	const [isValidPartner, setIsValidPartner] = useState(false)
	const [overStay, setOverStay] = useState(EMPTY_ARRAY)
	const { ticketId, partner } = useParams()
	// const [remainingAmount, setRemainingAmount] = useState(null)
	// const [partnerdetails, setPartnerDetails] = useState(EMPTY_OBJECT)
	const [loading, setLoading] = useState(true)
	const [defaultPromoCode, setDefaultPromoCode] = useState('')
	const [errorMessageLocal, setErrorMessageLocal] = useState('')
	const [pageLoad, setPageLoad] = useState(true)
	const [showCouponPriceonLoad, setShowCouponPriceonLoad] = useState(true)

	const { queryParams } = useQueryParams()
	const isWalletPermission = isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions'), 'Display Wallet Pass')

	// useEffect(() => {
	// 	console.log(overStay)
	// }, [EMPTY_ARRAY])

	const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')

	useEffect(() => {
		// setLoading(true)
		// dispatch(getPartnerDetailsBySLug(partner)).then((res) => {
		// 	setLoading(false)
		if (partnerDetails?.email) {
			// setPartnerDetails(res?.data)
			setIsValidPartner(true)
			localStorage.removeItem('partnerData')
			localStorage.setItem('partnerData', JSON.stringify(partnerDetails))
			const partnerData = partnerDetails
			let color = partnerData?.brand_setting ? partnerData?.brand_setting?.color : partnerData?.partner_details?.brand_setting?.color
			let rgb = partnerData?.brand_setting ? partnerData?.brand_setting?.rgb_color : partnerData?.partner_details?.brand_setting?.rgb_color
			rgb = JSON.parse(rgb)

			if (color) {
				document.documentElement.style.setProperty('--bs-primary', color)
				document.documentElement.style.setProperty('base-color', color)
				document.documentElement.style.setProperty('primary', color)
				document.documentElement.style.setProperty('textcolor', color)
				document.documentElement.style.setProperty('--bs-btn-bg', color)
				document.documentElement.style.setProperty('--bs-primary-rgb', `${rgb?.r},${rgb?.g},${rgb?.b}`)
				document.documentElement.style.setProperty('--bs-list-group-active-border-color', color)
				document.documentElement.style.setProperty('--bs-list-group-active-color', color)
				document.documentElement.style.setProperty('--bs-list-group-active-bg', color)
			}

			if (ticketDetailsFromProps && ticketDetailsFromProps?.ticket_number != '') {
				setTicketDetails(ticketDetailsFromProps)
				const isGatedNotCheckout = isCheckoutButton(ticketDetailsFromProps?.facility, ['1']) && (ticketDetailsFromProps?.is_checkout == 1 && ticketDetailsFromProps?.facility?.is_gated_facility != 0)
				const showPriceCoupon = isParksfo() ? !isGatedNotCheckout : false
				setShowCouponPriceonLoad(showPriceCoupon)
			} else {
				if (ticketId) {
					getReceiptDetails(ticketId, partnerData)
				} else if (queryParams?.get('qr') && queryParams?.get('qr') != '') {
					setLoading(true)
					// QR DETAILS ENDS HERE
					const queryParamData = queryParams?.get('qr')
					// Decode the Base64 string
					const decodedString = atob(queryParamData)
					// Split the decoded string into fields
					const fields = decodedString.split('||')

					// QR DETAILS STARTS HERE

					const payload = {
						'ref_number': fields?.[0] || '',
						'facility_id': fields?.[1] || '',
					}
					dispatch(getOfflineTicketDetailsQR(payload)).then((res) => {
						setLoading(false)
						if (res?.status === 201 || res?.status === 200) {
							if (res?.data && res?.data != null) {
								if (res?.data && res?.data != null && res?.data?.ticket && res?.data?.ticket != null) {
									res.data.ticket.ticket.facility = res?.data?.facility
									const ticketData = res.data.ticket.ticket
									setTicketDetails(ticketData)
									// EOS-517 EOS-2639
									const isGatedNotCheckout = isCheckoutButton(ticketData?.facility, ['1']) && (ticketData?.is_checkout == 1 && ticketData?.facility?.is_gated_facility != 0)
									const showPriceCoupon = isParksfo() ? !isGatedNotCheckout : false
									setShowCouponPriceonLoad(showPriceCoupon)
								} else {
									const ticketObject = {
										'ref_id': fields?.[0],
										'facility_id': fields?.[1],
										'check_in_datetime': fields?.[2],
										'estimated_checkout': fields?.[3],
										'rate_description': 'pims-8813-duration-4',
										'checkout_datetime': fields?.[3],
										'reservation_id': null,
										'checkin_gate': null,
										'checkout_gate': null,
										'is_checkin': '1',
										'is_checkout': '1',
										'total': fields?.[4] || '0.00',
										'grand_total': fields?.[4] || '0.00',
										'checkin_time': fields?.[2],
										'checkout_time': fields?.[3],
										'valet_parking_request_id': null,
										'parking_amount': fields?.[5] || '0.00',
										'processing_fee': fields?.[7] || '0.00',
										'checkout_without_checkin': '0',
										'vp_device_checkin': '1',
										'terminal_id': null,
										'tax_fee': fields?.[6] || '0.00',
										'scan_date': fields?.[2],
										'event_id': null,
										'worldpay_transaction_id': null,
										'old_worldpay_transaction_id': null,
										'checkout_qr_code': null,
										'vehicle_id': '12395',
										'paid_by': null,
										'paid_amount': null,
										'paid_remark': null,
										'paid_date': null,
										'paid_type': null,
										'paid_hour': null,
										'paid_days': null,
										'paid_percentage': null,
										'slot_no': null,
										'card_type': null,
										'expiry': null,
										'card_last_four': null,
										'state_id': null,
										'is_extended': null,
										'orignal_length': null,
										'stop_parking_time': null,
										'discount_amount': null,
										'promocode': null,
										'discount_hours': null,
										'checkout_by': null,
										'payment_gateway': null,
										'credit_used': null,
										'policy_id': null,
										'max_validated_amount': null,
										'checkout_remark': null,
										'admin_payment_comment': null,
										'is_offline_payment': '0',
										'session_id': null,
										'is_cloud_payment': '0',
										'affiliate_business_id': null,
										'deleted_at': null,
										'checkout_license_plate': null,
										'checkout_mode': '',
										'payment_by': null,
										'payment_method': null,
										'cardholder_name': null,
										'checkout_cardholder_name': null,
										'checkout_card_last_four': null,
										'checkout_expiry': null,
										'checkout_card_type': null,
										'checkout_session_id': null,
										'is_transaction_status': '0',
										'payment_token': null,
										'is_priceband_apply': '0',
										'facility_zone_id': null,
										'event_user_id': null,
										'permit_request_id': null,
										'refund_amount': null,
										'refund_type': null,
										'refund_remarks': null,
										'refund_date': null,
										'refund_by': null,
										'refund_transaction_id': null,
										'refund_status': null,
										'checkout_payment_token': null,
										'lpr_session_id': null,
										'cancelled_at': null,
										'customer_data': null,
										'checkout_facility_id': null,
										'checkin_gate_name': '',
										'checkout_gate_name': '',
										'overstay_amount': '0',
										'diff_in_days': null,
										'diff_in_hours': null,
										'diff_in_minutes': null,
										'facility': null,
										'payable_amount': 0,
										'tax_rate': fields?.[6] || '0.00',
										'extend_amount': '0.00',
										'is_price_applicable': '0',
										'amount_paid': fields?.[4] || '0.00',
										'payment': 1,
										'ticket_extend_allow': 0,
										'user': {
											'name': null,
											'phone': fields?.[9],
											'phone_number': fields?.[9],
										},
										'user_pass': null,
										'transaction': null,
										'permit': null,
										'ticket_extend': [],
										'overstay': [],
										CCFee: fields?.[10] || '0.00',
										surcharge_fee: fields?.[11] || '0.00'

									}
									ticketObject.facility = res?.data?.facility
									setTicketDetails(ticketObject)
								}

							} else {

								setLoading(false)
								// notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
								setPromptNumber(false)
								const ticketObject = {
									'ref_id': fields?.[0],
									'facility_id': fields?.[1],
									'check_in_datetime': fields?.[2],
									'estimated_checkout': fields?.[3],
									'rate_description': 'pims-8813-duration-4',
									'checkout_datetime': fields?.[3],
									'reservation_id': null,
									'checkin_gate': null,
									'checkout_gate': null,
									'is_checkin': '1',
									'is_checkout': '1',
									'total': fields?.[4] || '0.00',
									'grand_total': fields?.[4] || '0.00',
									'checkin_time': fields?.[2],
									'checkout_time': fields?.[3],
									'valet_parking_request_id': null,
									'parking_amount': fields?.[5] || '0.00',
									'processing_fee': fields?.[7] || '0.00',
									'checkout_without_checkin': '0',
									'vp_device_checkin': '1',
									'terminal_id': null,
									'tax_fee': fields?.[6] || '0.00',
									'scan_date': fields?.[2],
									'event_id': null,
									'worldpay_transaction_id': null,
									'old_worldpay_transaction_id': null,
									'checkout_qr_code': null,
									'vehicle_id': '12395',
									'paid_by': null,
									'paid_amount': null,
									'paid_remark': null,
									'paid_date': null,
									'paid_type': null,
									'paid_hour': null,
									'paid_days': null,
									'paid_percentage': null,
									'slot_no': null,
									'card_type': null,
									'expiry': null,
									'card_last_four': null,
									'state_id': null,
									'is_extended': null,
									'orignal_length': null,
									'stop_parking_time': null,
									'discount_amount': null,
									'promocode': null,
									'discount_hours': null,
									'checkout_by': null,
									'payment_gateway': null,
									'credit_used': null,
									'policy_id': null,
									'max_validated_amount': null,
									'checkout_remark': null,
									'admin_payment_comment': null,
									'is_offline_payment': '0',
									'session_id': null,
									'is_cloud_payment': '0',
									'affiliate_business_id': null,
									'deleted_at': null,
									'checkout_license_plate': null,
									'checkout_mode': '',
									'payment_by': null,
									'payment_method': null,
									'cardholder_name': null,
									'checkout_cardholder_name': null,
									'checkout_card_last_four': null,
									'checkout_expiry': null,
									'checkout_card_type': null,
									'checkout_session_id': null,
									'is_transaction_status': '0',
									'payment_token': null,
									'is_priceband_apply': '0',
									'facility_zone_id': null,
									'event_user_id': null,
									'permit_request_id': null,
									'refund_amount': null,
									'refund_type': null,
									'refund_remarks': null,
									'refund_date': null,
									'refund_by': null,
									'refund_transaction_id': null,
									'refund_status': null,
									'checkout_payment_token': null,
									'lpr_session_id': null,
									'cancelled_at': null,
									'customer_data': null,
									'checkout_facility_id': null,
									'checkin_gate_name': '',
									'checkout_gate_name': '',
									'overstay_amount': '0',
									'diff_in_days': null,
									'diff_in_hours': null,
									'diff_in_minutes': null,
									'facility': null,
									'payable_amount': 0,
									'tax_rate': fields?.[6] || '0.00',
									'extend_amount': '0.00',
									'is_price_applicable': '0',
									'amount_paid': fields?.[4] || '0.00',
									'payment': 1,
									'ticket_extend_allow': 0,
									'user': {
										'name': null,
										'phone': fields?.[9],
										'phone_number': fields?.[9],
									},
									'user_pass': null,
									'transaction': null,
									'permit': null,
									'ticket_extend': [],
									'overstay': [],
									CCFee: fields?.[10] || '0.00',
									surcharge_fee: fields?.[11] || '0.00'

								}
								setTicketDetails(ticketObject)
							}
						} else {
							setLoading(false)
							const ticketObject = {
								'ref_id': fields?.[0],
								'facility_id': fields?.[1],
								'check_in_datetime': fields?.[2],
								'estimated_checkout': fields?.[3],
								'rate_description': 'pims-8813-duration-4',
								'checkout_datetime': fields?.[3],
								'reservation_id': null,
								'checkin_gate': null,
								'checkout_gate': null,
								'is_checkin': '1',
								'is_checkout': '1',
								'total': fields?.[4] || '0.00',
								'grand_total': fields?.[4] || '0.00',
								'checkin_time': fields?.[2],
								'checkout_time': fields?.[3],
								'valet_parking_request_id': null,
								'parking_amount': fields?.[5] || '0.00',
								'processing_fee': fields?.[7] || '0.00',
								'checkout_without_checkin': '0',
								'vp_device_checkin': '1',
								'terminal_id': null,
								'tax_fee': fields?.[6] || '0.00',
								'scan_date': fields?.[2],
								'event_id': null,
								'worldpay_transaction_id': null,
								'old_worldpay_transaction_id': null,
								'checkout_qr_code': null,
								'vehicle_id': '12395',
								'paid_by': null,
								'paid_amount': null,
								'paid_remark': null,
								'paid_date': null,
								'paid_type': null,
								'paid_hour': null,
								'paid_days': null,
								'paid_percentage': null,
								'slot_no': null,
								'card_type': null,
								'expiry': null,
								'card_last_four': null,
								'state_id': null,
								'is_extended': null,
								'orignal_length': null,
								'stop_parking_time': null,
								'discount_amount': null,
								'promocode': null,
								'discount_hours': null,
								'checkout_by': null,
								'payment_gateway': null,
								'credit_used': null,
								'policy_id': null,
								'max_validated_amount': null,
								'checkout_remark': null,
								'admin_payment_comment': null,
								'is_offline_payment': '0',
								'session_id': null,
								'is_cloud_payment': '0',
								'affiliate_business_id': null,
								'deleted_at': null,
								'checkout_license_plate': null,
								'checkout_mode': '',
								'payment_by': null,
								'payment_method': null,
								'cardholder_name': null,
								'checkout_cardholder_name': null,
								'checkout_card_last_four': null,
								'checkout_expiry': null,
								'checkout_card_type': null,
								'checkout_session_id': null,
								'is_transaction_status': '0',
								'payment_token': null,
								'is_priceband_apply': '0',
								'facility_zone_id': null,
								'event_user_id': null,
								'permit_request_id': null,
								'refund_amount': null,
								'refund_type': null,
								'refund_remarks': null,
								'refund_date': null,
								'refund_by': null,
								'refund_transaction_id': null,
								'refund_status': null,
								'checkout_payment_token': null,
								'lpr_session_id': null,
								'cancelled_at': null,
								'customer_data': null,
								'checkout_facility_id': null,
								'checkin_gate_name': '',
								'checkout_gate_name': '',
								'overstay_amount': '0',
								'diff_in_days': null,
								'diff_in_hours': null,
								'diff_in_minutes': null,
								'facility': null,
								'payable_amount': 0,
								'tax_rate': fields?.[6] || '0.00',
								'extend_amount': '0.00',
								'is_price_applicable': '0',
								'amount_paid': fields?.[4] || '0.00',
								'payment': 1,
								'ticket_extend_allow': 0,
								'user': {
									'name': null,
									'phone': fields?.[9],
									'phone_number': fields?.[9],
								},
								'user_pass': null,
								'transaction': null,
								'permit': null,
								'ticket_extend': [],
								'overstay': [],
								CCFee: fields?.[10] || '0.00',
								surcharge_fee: fields?.[11] || '0.00'

							}
							setTicketDetails(ticketObject)
							// setError(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
							// notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
							setPromptNumber(false)
						}
					}).catch(() => {
						setLoading(false)
						// notify('error', errorMessage?.somethingWentWrong)
						setPromptNumber(false)
						const ticketObject = {
							'ref_id': fields?.[0],
							'facility_id': fields?.[1],
							'check_in_datetime': fields?.[2],
							'estimated_checkout': fields?.[3],
							'rate_description': 'pims-8813-duration-4',
							'checkout_datetime': fields?.[3],
							'reservation_id': null,
							'checkin_gate': null,
							'checkout_gate': null,
							'is_checkin': '1',
							'is_checkout': '1',
							'total': fields?.[4] || '0.00',
							'grand_total': fields?.[4] || '0.00',
							'checkin_time': fields?.[2],
							'checkout_time': fields?.[3],
							'valet_parking_request_id': null,
							'parking_amount': fields?.[5] || '0.00',
							'processing_fee': fields?.[7] || '0.00',
							'checkout_without_checkin': '0',
							'vp_device_checkin': '1',
							'terminal_id': null,
							'tax_fee': fields?.[6] || '0.00',
							'scan_date': fields?.[2],
							'event_id': null,
							'worldpay_transaction_id': null,
							'old_worldpay_transaction_id': null,
							'checkout_qr_code': null,
							'vehicle_id': '12395',
							'paid_by': null,
							'paid_amount': null,
							'paid_remark': null,
							'paid_date': null,
							'paid_type': null,
							'paid_hour': null,
							'paid_days': null,
							'paid_percentage': null,
							'slot_no': null,
							'card_type': null,
							'expiry': null,
							'card_last_four': null,
							'state_id': null,
							'is_extended': null,
							'orignal_length': null,
							'stop_parking_time': null,
							'discount_amount': null,
							'promocode': null,
							'discount_hours': null,
							'checkout_by': null,
							'payment_gateway': null,
							'credit_used': null,
							'policy_id': null,
							'max_validated_amount': null,
							'checkout_remark': null,
							'admin_payment_comment': null,
							'is_offline_payment': '0',
							'session_id': null,
							'is_cloud_payment': '0',
							'affiliate_business_id': null,
							'deleted_at': null,
							'checkout_license_plate': null,
							'checkout_mode': '',
							'payment_by': null,
							'payment_method': null,
							'cardholder_name': null,
							'checkout_cardholder_name': null,
							'checkout_card_last_four': null,
							'checkout_expiry': null,
							'checkout_card_type': null,
							'checkout_session_id': null,
							'is_transaction_status': '0',
							'payment_token': null,
							'is_priceband_apply': '0',
							'facility_zone_id': null,
							'event_user_id': null,
							'permit_request_id': null,
							'refund_amount': null,
							'refund_type': null,
							'refund_remarks': null,
							'refund_date': null,
							'refund_by': null,
							'refund_transaction_id': null,
							'refund_status': null,
							'checkout_payment_token': null,
							'lpr_session_id': null,
							'cancelled_at': null,
							'customer_data': null,
							'checkout_facility_id': null,
							'checkin_gate_name': '',
							'checkout_gate_name': '',
							'overstay_amount': '0',
							'diff_in_days': null,
							'diff_in_hours': null,
							'diff_in_minutes': null,
							'facility': null,
							'payable_amount': 0,
							'tax_rate': fields?.[6] || '0.00',
							'extend_amount': '0.00',
							'is_price_applicable': '0',
							'amount_paid': fields?.[4] || '0.00',
							'payment': 1,
							'ticket_extend_allow': 0,
							'user': {
								'name': null,
								'phone': fields?.[9],
								'phone_number': fields?.[9],
							},
							'user_pass': null,
							'transaction': null,
							'permit': null,
							'ticket_extend': [],
							'overstay': [],
							CCFee: fields?.[10] || '0.00',
							surcharge_fee: fields?.[11] || '0.00'

						}
						setTicketDetails(ticketObject)
					})



				} else {
					setLoading(false)
					setTicketDetails('')
					setPromptNumber(false)
				}
			}


		} else {
			setIsValidPartner(true)
			localStorage.removeItem('partnerData')
		}

		// }).catch((err) => {
		// 	setLoading(false)
		// 	console.log('error'+ err)

		// })


	}, [EMPTY_ARRAY, ticketDetailsFromProps, isNumberUpdated])

	const getReceiptDetails = (ticketId = '', partnerData = {}) => {
		const payload = {
			'ticket': ticketId,
			'phone': loggedInUserData()?.user?.phone_number ? loggedInUserData()?.user?.phone_number : '',
			'cardLast4': '',
			'cardExpiry': '',
			'license_plate': '',
			'role': partnerData?.roles?.[0],
			'id': partnerData?.id,
			'is_event': isEvent ? 1 : 0
		}
		setLoading(true)
		dispatch(getExtendList(ticketId)).then((ticketRes) => {
			const overStayDetails = getTotalOverstayPaidAmount(ticketRes?.data)
			setOverStay(overStayDetails)
		}).catch((ticketErr) => {
			const payload = {
				ticket_id: ticketId,
				error: ticketErr
			}
			dispatch(addEventLog(payload, CONSTANTS.UNEXPECTED_ERROR))
		})
		dispatch(getTicketDetails(payload)).then((res) => {
			setLoading(false)
			if (res?.status === 201 || res?.status === 200) {
				if (res?.data && res?.data != null) {
					// notify('success', 'T successfully')

					// EOS-517 EOS-2639
					const isGatedNotCheckout = isCheckoutButton(res?.data?.facility, ['1']) && (res?.data?.is_checkout == 1 && res?.data?.facility?.is_gated_facility != 0)
					const showPriceCoupon = isParksfo() ? !isGatedNotCheckout : false
					setShowCouponPriceonLoad(showPriceCoupon)

					// for the prompt open for number 
					if ((!res?.data?.user?.phone && !res?.data?.user?.phone_number) || (!res?.data?.user?.phone > 9 && !res?.data?.user?.phone_number > 9)) {
						setPromptNumber(true)
					}
					if (res?.data?.facility?.facilty_brand_setting?.color) {
						const color = res?.data?.facility?.facilty_brand_setting?.color
						const rgb = JSON.parse(res?.data?.facility?.facilty_brand_setting?.rgb_color)
						if (color) {
							document.documentElement.style.setProperty('--bs-primary', color)
							document.documentElement.style.setProperty('base-color', color)
							document.documentElement.style.setProperty('primary', color)
							document.documentElement.style.setProperty('textcolor', color)
							document.documentElement.style.setProperty('--bs-btn-bg', color)
							document.documentElement.style.setProperty('--bs-primary-rgb', `${rgb?.r},${rgb?.g},${rgb?.b}`)
							document.documentElement.style.setProperty('--bs-list-group-active-border-color', color)
							document.documentElement.style.setProperty('--bs-list-group-active-color', color)
							document.documentElement.style.setProperty('--bs-list-group-active-bg', color)
						}
					}
					//
					localStorage.setItem('facilityBrandSettings', JSON.stringify(res?.data?.facility?.facilty_brand_setting))
					localStorage.setItem('userPhone', res?.data?.user?.phone ? res?.data?.user?.phone : '')
					localStorage.setItem('user_Phone_number', res?.data?.user?.phone_number ? res?.data?.user?.phone_number : '')
					setTicketDetails(res?.data)

				} else {
					setLoading(false)
					notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
					setPromptNumber(false)
					setTicketDetails(null)
				}
			} else {
				setLoading(false)
				setError(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
				// notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
				setPromptNumber(false)
				setTicketDetails(null)
			}
		}).catch(() => {
			setLoading(false)
			notify('error', errorMessage?.somethingWentWrong)
			setPromptNumber(false)
			setTicketDetails(null)
		})
	}

	const handleEndParking = () => {
		dispatch(endParking(ticketDetails?.ticket_number)).then((res) => {
			if (res?.status === 201 || res?.status === 200) {
				if (res?.data && res?.data != null) {
					notify('success', res?.data?.end_parking_message || errorMessage?.endParkingSuccessMessage)
					setTicketDetails(res?.data)
					setTimeout(() => {
						navigate(0)
					}, 3000)
				} else {
					notify('success', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
					setTimeout(() => {
						navigate(0)
					}, 3000)
				}
			} else {
				setError(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
				notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
			}
		}).catch(() => {
			notify('error', errorMessage?.somethingWentWrong)
		})
	}

	const handleDownloadTicket = () => {
		const payload = {
			ticket_number: isEvent ? ticketDetails?.id : ticketId,
			is_event: isEvent ? 1 : 0
		}
		dispatch(downloadTicket(payload)).then((res) => {
			if (res?.status && res?.status == 500) {
				notify('error', errorMessage?.somethingWentWrong)
			}
			notify('Success', 'E-Ticket Downloaded')

		}).catch(() => {
			notify('error', errorMessage?.somethingWentWrong)
		})
	}

	const handlePromptset = () => {
		setPromptNumber(!isPromptOpen)
	}


	const handleValidateTicket = (paymentData) => {
		if (paymentData?.paid_date) {
			notify('error', 'This ticket is already validated.')
		} else {
			navigate(`/${partner}${URL?.SCAN_VALIDATE}/${paymentData?.ticket_number}`)
		}
	}

	// const handleDetailsDisplay = () => {
	// 	setIsDisplayDetails(true)
	// }

	const redirectPermitLink = () => {
		let redirectURL = `${window?.location?.toString()?.includes('rev-pass') ? getConfigDetails?.revcheckInUrl : window?.location?.toString()?.includes('breeze') ? getConfigDetails?.pciCheckInUrl : getConfigDetails?.checkInUrl}/${partner}/permit-link?ticket=${ticketDetails?.encrypt_ticket_number}`
		window.location.href = redirectURL
    }

	return (
		isFetchingPartner || loading ? <Loader /> : <div className={ticketId ? 'main' : ''}>
			{(ticketId || ticketDetails?.ref_id || ticketDetails?.ticket_number) && <MiniHeader partnerdetails={partnerDetails} title={loader ? '' : ticketDetails?.is_expired == 0 ? 'e-Ticket' : 'e-Receipt'} handleDownload={handleDownloadTicket} download={isEvent ? ticketDetails?.ticketech_code : ticketDetails?.id ? true : false} facilityData={ticketDetails} />}
			{(isValidPartner) ? loader ? <Loader /> :
				(ticketDetails?.ticket_number && ticketDetails?.ticket_number != '') || ticketDetails?.ref_id ?
					<div className={`${ticketId ? 'm-2 ' : ''}card shadow-lg bg-white rounded border-0 ticket-font`}>

						{/* </div> */}
						<div className='card-body m-0 p-0 pb-5'>
							<div className='clearfix example '>

								{/* THANK YOU */}
								<div className=' text-center pt-2 pb-3'>
									{/* <img src={thankyou} className='imgh-20 thankyou-img-height-80 mt-2' alt='Thank You'/> */}
									<h6 className='mt-3 fw-bold mb-3 ticket-font'>Thank You for Parking!</h6>
									{/* <p className='ms-2 me-2 text-black mt-2 pb-0 mb-0 ticket-font'>For parking with {ticketDetails?.facility?.full_name}</p> */}
								</div>
								<div className='row m-2 border border-primary pe-0'>
									{(ticketDetails?.ticket_number || ticketId) && (
										<div className='col-3 m-0 p-0 ms-2 mt-2 mb-2 responsive-canvas'>
											<QRCodeSVG
												value={
													ticketDetails?.facility?.facility_configuration?.is_sbm_event_qrcode == 1 ?
														ticketDetails?.mapco_qr_code?.[0]?.qrcode || ticketDetails?.ticket_security_code :
														ticketDetails?.reservation?.ticketech_code ?
															ticketDetails.reservation.ticketech_code :
															ticketDetails?.validate_url ? ticketDetails?.validate_url :
																`${window?.location?.toString()?.includes('rev-pass') ? 
																	getConfigDetails?.revadminUrl : 
																	window?.location?.toString()?.includes('breeze') ? 
																	getConfigDetails?.pciAdminUrl : 
																	getConfigDetails?.adminUrl}/admin/tickets?ticket_number=${ticketDetails?.ticket_number}`}
												width='100%'
												height="100%"
											// size={180}
											/>
										</div>)}
									<div className={`${ticketDetails?.ref_id && ticketDetails?.ref_id != '' ? 'col-12' : 'col-9'} col-auto row  me-0 pe-0`}>
										<div className='col-12 ps-2 mt-3 mb-2 me-0 pe-0'>
											{ticketDetails?.ref_id && <span className='text-start text-primary small pb-0 mb-0'>Ref ID: {ticketDetails?.ref_id}</span>}
											{(ticketDetails?.ticket_number || ticketDetails?.ticketech_code) ? <span className='text-start text-primary small pb-0 mb-0'>Ticket ID: {ticketDetails?.ticket_number || ticketDetails?.ticketech_code}</span> : null}
											<a href={getLocation(ticketDetails?.facility)} target="_blank" rel="noreferrer" className='float-end me-1'><img src={direction} alt="Direction" className='direction' /></a>
											<h6 className='text-start text-primary mt-2 mb-0 fw-bold small'>{ticketDetails?.facility?.full_name} {ticketDetails?.is_checkout == 0 ? ticketDetails?.checkin_gate_name ? `(${ticketDetails?.checkin_gate_name})` : '' : ticketDetails?.checkout_gate_name ? `(${ticketDetails?.checkout_gate_name})` : ''}</h6>
											<p className='text-start text-black pb-0 mb-0 small'>Entrance: {ticketDetails?.facility?.entrance_location ? ticketDetails?.facility?.entrance_location : `${ticketDetails?.facility?.geolocations?.address_1 ? `${ticketDetails?.facility?.geolocations?.address_1},` : ''} ${ticketDetails?.facility?.geolocations?.city ? `${ticketDetails?.facility?.geolocations?.city},` : ''} ${ticketDetails?.facility?.geolocations?.state ? ticketDetails?.facility?.geolocations?.state : ''}`}
											</p>
											{(ticketDetails?.paid_date) && <p className='text-start text-black pb-0 mb-0 small'>Status: <span className='p-0 m-0 ms-3 ticket-font text-success'><i className="fa fa-check" aria-hidden="true"></i> Validated</span> </p>}
										</div>
										{/* <div className='col-4 d-flex align-items-center justify-content-end'>
									</div> */}
									</div>
								</div>
							</div>
							<div className='m-2 mt-5'>
								<h6>Details</h6>
							</div>
							<div className=' mt-0 m-2 small'>
								<div className='row m-0 bg-white d-flex align-items-center px-2 pt-2'>

									<div className='col-sm-12 col-sm-8 p-0 m-0'>
										{ticketDetails?.ticket_details?.name && <div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Name</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className='p-0 m-0 ticket-font'>{ticketDetails?.ticket_details?.name ? ticketDetails?.ticket_details?.name : '-'}</p>
											</div>
										</div>}
										{ticketDetails?.ticket_details?.email && <div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Email Id</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className='p-0 m-0 ticket-font'>{ticketDetails?.ticket_details?.email ? ticketDetails?.ticket_details?.email : '-'}</p>
											</div>
										</div>}
										{ticketDetails?.ticket_details?.phone && <div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Phone No</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className='p-0 m-0 ticket-font'>{ticketDetails?.ticket_details?.phone ? phoneMasker(ticketDetails?.ticket_details?.phone) : '-'}</p>
											</div>
										</div>}
										{(ticketDetails?.reservation && ticketDetails?.reservation?.ticketech_code) && <div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Booking ID</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className='p-0 m-0 ticket-font'>{ticketDetails?.reservation?.ticketech_code ? ticketDetails?.reservation?.ticketech_code : '-'}</p>
											</div>
										</div>}
										{(ticketDetails?.license_plate || ticketDetails?.checkout_license_plate) && <div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>License Plate</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className='p-0 m-0 ticket-font'>{ticketDetails?.license_plate ? ticketDetails?.license_plate : ticketDetails?.checkout_license_plate ? ticketDetails?.checkout_license_plate : '-'}</p>
											</div>
										</div>}
										{/* {ticketDetails?.ticket_number && <div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Ticket ID</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className='p-0 m-0 ticket-font'>{ticketDetails?.ticket_number ? `${ticketDetails?.ticket_number}` : '-'}</p>
											</div>
										</div>} */}
										{/* {ticketDetails?.checkin_gate && <div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Check-In Gate</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className='p-0 m-0 ticket-font'>{ticketDetails?.checkin_gate ? `${ticketDetails?.checkin_gate}` : '-'}</p>
											</div>
										</div>}
										{ticketDetails?.checkout_gate && <div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Check-Out Gate</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className='p-0 m-0 ticket-font'>{ticketDetails?.checkout_gate ? `${ticketDetails?.checkout_gate}` : '-'}</p>
											</div>
										</div>} */}
										<div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Check-In Time</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												{/* <p >{ticketDetails?.checkin_time ? moment(ticketDetails?.checkin_time).format('Do MMM YYYY h:mmA') : '-'}</p> */}
												<p className=' p-0 m-0  ticket-font'>{ticketDetails?.checkin_time ? moment(ticketDetails?.checkin_time).format('MM/DD/YYYY hh:mm A') : '-'}</p>
											</div>
										</div>
										<div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Check-Out Time</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className=' p-0 m-0  ticket-font'>{ticketDetails?.checkout_time ? moment(ticketDetails?.checkout_time).format('MM/DD/YYYY hh:mm A') : '-'}</p>
											</div>
										</div>
										<div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Total Duration</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className=' p-0 m-0  ticket-font'>{getTotalTimeDuration(ticketDetails)}</p>
											</div>
										</div>
										<div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Early Checkout Time</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className=' p-0 m-0  ticket-font'>{ticketDetails?.stop_parking_time ? moment(ticketDetails?.stop_parking_time).format('MM/DD/YYYY hh:mm A') : '-'}</p>
											</div>
										</div>

										{/* Events Details */}

										{(ticketDetails?.mapco_qr_code && ticketDetails?.mapco_qr_code?.length > 0) ? <div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Event Name</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className=' p-0 m-0  ticket-font'>{ticketDetails?.mapco_qr_code?.[0]?.event?.title ? ticketDetails?.mapco_qr_code?.[0]?.event?.title : '-'}</p>
											</div>
										</div> : null}

										{(ticketDetails?.mapco_qr_code && ticketDetails?.mapco_qr_code?.length > 0) ? <div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Start Time</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className=' p-0 m-0  ticket-font'>{ticketDetails?.mapco_qr_code?.[0]?.event?.start_time ? moment(ticketDetails?.mapco_qr_code?.[0]?.event?.start_time)?.format('MM/DD/YYYY hh:mm A') : '-'}</p>
											</div>
										</div> : null}
										{(ticketDetails?.mapco_qr_code && ticketDetails?.mapco_qr_code?.length > 0) ? <div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>End Time</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className=' p-0 m-0  ticket-font'>{ticketDetails?.mapco_qr_code?.[0]?.event?.end_time ? moment(ticketDetails?.mapco_qr_code?.[0]?.event?.end_time)?.format('MM/DD/YYYY hh:mm A') : '-'}</p>
											</div>
										</div> : null}

										{/* Events Details */}


										<div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Card Type</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className=' p-0 m-0  ticket-font'>{ticketDetails?.card_type ? ticketDetails?.card_type : ticketDetails?.transaction?.card_type ? ticketDetails?.transaction?.card_type : '-'}</p>
											</div>
										</div>
										<div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Payment Method</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className=' p-0 m-0  ticket-font'>{ticketDetails?.card_last_four ? `Ending with ${ticketDetails?.card_last_four}` : ticketDetails?.transaction?.payment_last_four ? `Ending with ${ticketDetails?.transaction?.payment_last_four}` : '-'}</p>
											</div>
										</div>
										<div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Card Expiry</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className=' p-0 m-0  ticket-font'>{ticketDetails?.expiry ? formattedExpiry(ticketDetails?.expiry) : ticketDetails?.transaction?.expiration ? formattedExpiry(ticketDetails?.transaction?.expiration) : '-'}</p>
											</div>
										</div>
										{(ticketDetails?.lot_facility && ticketDetails?.lot_facility != '' && ticketDetails?.lot_facility?.id != ticketDetails?.facility?.id) ? <div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Check-In Facility</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className=' p-0 m-0  ticket-font'>{ticketDetails?.lot_facility?.full_name ? ticketDetails?.lot_facility?.full_name : '-'}</p>
											</div>
										</div> : null}

										<div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Check-In Against Pass</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className=' p-0 m-0  ticket-font'>{ticketDetails?.user_pass?.pass_code ? ticketDetails?.user_pass?.pass_code : '-'}</p>
											</div>
										</div>
										<div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Total Usage</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className=' p-0 m-0  ticket-font'>{ticketDetails?.user_pass?.total_days ? ticketDetails?.user_pass?.total_days : '-'}</p>
											</div>
										</div>
										<div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Remaining Usage</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className=' p-0 m-0  ticket-font'>{ticketDetails?.user_pass?.remaining_days ? ticketDetails?.user_pass?.remaining_days : '-'}</p>
											</div>
										</div>

										{/* DIsplay if the Checkin is Done against Permit */}
										<div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Check-In Against Permit</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className=' p-0 m-0  ticket-font'>{ticketDetails?.permit?.account_number ? `#${ticketDetails?.permit?.account_number}` : '-'}</p>
											</div>
										</div>
										{/* DIsplay if the Checkin is Done against Permit */}

										<div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Check-In Against Event</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className=' p-0 m-0  ticket-font'>{ticketDetails?.event?.event_id ? `#${ticketDetails?.event?.event_id}` : '-'}</p>
											</div>
										</div>
										<div className='col-12 m-auto border-bottom row d-flex align-items-center'>
											<div className='col-5 small p-0 m-0 pt-2 pb-2'>
												<p className='fw-bold p-0 m-0 ticket-font'>Fast Track Enabled</p>
											</div>
											<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
												<p className=' p-0 m-0  ticket-font'>{ticketDetails?.is_fast_track == '1' || ticketDetails?.ticket_details?.is_fast_track_enabled == '1' ? 'Yes' : 'No'}</p>
											</div>
										</div>


										{/* {(ticketDetails?.amount_paid && Number(ticketDetails?.payable_amount) == 0) ?
											<div className='col-12 m-auto border-bottom row d-flex align-items-center'>
												<div className='col-5 small p-0 m-0 pt-2 pb-2'>
													<p className='fw-bold p-0 m-0 ticket-font'>Amount Paid</p>
												</div>
												<div className='col-7 small p-0 m-0 pt-2 pb-2 ps-2 '>
													<p className=' p-0 m-0 ticket-font'>{ticketDetails?.amount_paid ? ((ticketDetails?.reservation) ? overStay ? overStay : 'Prepaid' : `$${Number(ticketDetails?.amount_paid).toFixed(2)}`) : '-'}
														{(priceGreaterOrNot(ticketDetails) || ticketDetails?.is_overstay == '1') && <i className='fa fa-info-circle text-primary ms-1 cursor-pointer' onClick={() => handleDetailsDisplay()}></i>}
													</p>
												</div>
											</div>
											: null
										} */}
										{showCouponPriceonLoad ? null : <div className='p-2'>
											{((ticketDetails?.is_expired == '0') && isPromoValidateButton(ticketDetails, ['1', '3'])) ? <Promocode
												setTicketDetails={setTicketDetails}
												notify={notify}
												setErrorMessageLocal={setErrorMessageLocal}
												screen='main'
												defaultPromoCode={defaultPromoCode}
												setDefaultPromoCode={setDefaultPromoCode}
												ticketDetails={ticketDetails}
												errorMessageLocal={errorMessageLocal}
												setPageLoad={setPageLoad}
												pageLoad={pageLoad}
											/> : null}
										</div> }

										{(
											ticketDetails?.payable_amount != null || ticketDetails?.parking_amount != null
											// && Number(ticketDetails?.payable_amount) > 0
											// Above commented due to the Info icon issue of Price breakup
										) ? <>
											{showCouponPriceonLoad ? null : <div className='mt-3'>
												<div className="container pt-3 pb-5 overflow-hidden">
													<div className={getBreakUpDetails(ticketDetails)?.length ? 'card shadow rounded-lg receiptCard' : 'card shadow rounded-lg receiptCard no-view'}>
														<PaymentBreakUpDetails
															className="d-flex justify-content-between"
															paymentData={ticketDetails}
															sectionKey={((Number(ticketDetails?.payable_amount) != 0 || Number(ticketDetails?.payable_amount) > 0) && ticketDetails?.facility?.is_gated_facility == 1) ? '' : 'paymantResponse'}
															isDisplayDetails={isDisplayDetails}
															setIsDisplayDetails={setIsDisplayDetails}
															isExtendDetails
															overStay={overStay}
														/>
													</div>
												</div>
											</div> }
										</> : null}

										{isCheckoutButton(ticketDetails?.facility, ['1']) && (ticketDetails?.is_checkout == 0 && ticketDetails?.facility?.is_gated_facility != 0) ? <div>
											<div className='col-12 m-auto border border-primary rounded mt-3 bg-primary row d-flex align-items-center'>

											<a
												href={`${window?.location?.toString()?.includes('rev-pass') ? getConfigDetails?.revcheckInUrl : window?.location?.toString()?.includes('breeze') ? getConfigDetails?.pciCheckInUrl : getConfigDetails?.checkInUrl}/${partner}/${ticketDetails?.encrypt_ticket_number}/${loggedInUserData()?.access_token ? loggedInUserData()?.access_token : ''}`}
												type='button'
												className='btn text-decoration-none border-primary rounded'
											><div className='text-center bg-primary text-white text-decoration-none'>
													<p className='p-0 m-0 ticket-font fw-bold text-center'>Click to Check-Out</p>
												</div></a>
											</div>
											{isPermissionExist(getAccessPermissionData, 'Enable Gated Permit Link') && <Container className='mt-3 p-0' ><div className="bg-primary bg-opacity-10  p-4 m-1 rounded-3 mb-4">
													<div className='d-flex flex-row justify-content-between gap-3 mb-3 align-items-center'>
													<p className=" fw-bold m-0">
													If you are an <span className="text-primary">existing monthly permit holder. </span>
													Please click on the below button to  attach this
													<span className="text-primary"> ticket with your Permit.</span>
												</p>
												<img src={HeroIcon} alt="HeroIcon" height={60} width={60} />
												</div>
												<button onClick={redirectPermitLink} className="btn bg-white border border-primary text-primary fw-semibold  d-block w-100 ">Confirm details and link your permit</button>
												</div>
											</Container>}	
										</div> : null}
										{((ticketDetails?.is_expired == '0') && ticketDetails?.facility?.facility_configuration?.is_display_validate_button == 1 && isPromoValidateButton(ticketDetails, ['2', '3']) && (isPermissionExist(getAccessPermissionData, 'Enable self-validation for paid tickets') || !ticketDetails?.anet_transaction_id) && ticketDetails?.is_checkout == 0 && !ticketDetails?.paid_date && !ticketDetails?.promocode && !ticketDetails?.reservation_id && !ticketDetails?.user_pass_id && !ticketDetails?.permit_request_id) ? <div className='mt-3 mb-2'>
											<div className='col-sm-12 small'>
												<button
													type="button"
													className='btn border-primary border-btn d-block w-100'
													onClick={() => handleValidateTicket(ticketDetails)}
												>
													Validate Ticket
												</button>
											</div>
										</div> : null}
										{(ticketDetails?.facility?.is_gated_facility != '1' && ticketDetails?.is_expired == '0') && <div className='mt-3 mb-5'>
											{(isExtendButton(ticketDetails?.facility, ['1']) && isValidPartner && !ticketDetails?.reservation_id && !ticketDetails?.event_id && !ticketDetails?.user_pass_id && !ticketDetails?.permit_request_id) && <div className='col-sm-12 small'>
												<a
													href={`${window?.location?.toString()?.includes('rev-pass') ? getConfigDetails?.revtransientURL : window?.location?.toString()?.includes('breeze') ? getConfigDetails?.pciTransientURL : getConfigDetails?.transientURL}/${partner}/extend/${ticketDetails?.ticket_number}`}
													type='button'
													className='btn text-primary border-primary border-btn d-block w-100'>
													<i className='fa fa-plus-circle text-primary'></i> Extend
												</a>
												{/* className='text-decoration-none w-100 border bg-white text-center text-primary border-primary rounded ps-4 pe-4 fw-bold pt-2 pb-2' */}
											</div>}
											{/* Hide This */}
											{(ticketDetails?.facility?.is_end_parking == '1' && !ticketDetails?.permit_request_id && !ticketDetails?.event_id && !ticketDetails?.user_pass_id && !ticketDetails?.reservation_id) && <div className='col-sm-12 small mt-3 mb-5'>
												<button
													type='button'
													className='btn text-decoration-none border w-100 bg-white text-center text-primary border-primary border-btn rounded '
													onClick={() => handleEndParking()}>
													<div className='d-flex justify-content-center align-items-center'>
														<span>End Current Parking</span>
														<span className='ms-2'>
															{isFetching ? <Circles
																height="20"
																width="20"
																style={{ display: 'inline-block' }}
																color="#27A8E1"
																ariaLabel="circles-loading"
																visible={true}
															/> : null}
														</span>
													</div>
												</button>
											</div>}
											{isWalletPermission ? <div className="col-sm-12 mt-3">
												<PassWalletButtons ticketId={ticketDetails?.ticket_number} />
											</div> : null}

										</div>}
										{isWalletPermission ? <PassWalletButtons ticketId={ticketDetails?.ticket_number} /> : null}
									</div>
								</div>
							</div>

						</div>
						{/* <div className="card-footer row p-2 m-0 bg-primary">
						<div className='col-7 d-flex align-items-center justify-content-left'>
							<p className=" text-right my-2 text-white fw-bold">Paid Amount</p>
						</div>
						<div className='col-5 d-flex align-items-center justify-content-end'>
							<p className="my-2 ps-3 pe-3 text-white d-flex pt-1 pb-1 small h5">{ti	cketDetails?.grand_total ? `$${ticketDetails?.grand_total}` : 'NA'}</p>
						</div>
						
					</div> */}
					</div> : error && <NoData message={error} />
				: <NoData message={errorMessage?.invalidPartner} />}
			
			{(ticketId || ticketDetails?.ticket_number) && <Footer />}
			{/* <DownloadApp/> */}
			{loaderDownload && <div className='top-0 justify-content-center position-fixed w-100 h-100 zIndexHigh bg-black d-flex align-items-center opacity text-center opacity-25 text-white'>
				<i className='fa fa-spinner fa-spin'></i>
			</div>}

			<PromptNumberUpdate
				isPromptModalOpen={isPromptOpen}
				setPromptNumber={setPromptNumber}
				setIsPromptModal={handlePromptset}
				Message='Please link you phone number'
				isInputShow
				ticketDetails={ticketDetails}
				setTicketDetails={setTicketDetails}
				notify={notify}
				setIsNumberUpdated={setIsNumberUpdated}
			/>
		</div>

	)
}


Ticket.propTypes = {
	dispatch: PropTypes.func,
	loader: PropTypes.bool,
	loaderSms: PropTypes.bool,
	loaderDownload: PropTypes.bool,
	isFetching: PropTypes.bool,
	ticketDetailsFromProps: PropTypes.object,
	notify: PropTypes.func,
	isFetchingPartner: PropTypes.bool,
	partnerDetails: PropTypes?.object,
	isEvent: PropTypes.bool,
}

Ticket.defaulProps = {
	dispatch: noop,
	loader: false,
	isFetching: false,
	ticketDetailsFromProps: {},
	notify: noop,
	isFetchingPartner: true,
	partnerDetails: EMPTY_OBJECT,
	isEvent: false,
}

function mapStateToProps({ userDetailsReducer, transientReducer }) {
	return {
		loader: userDetailsReducer?.loader,
		loaderSms: userDetailsReducer?.loaderSms,
		loaderDownload: userDetailsReducer?.loaderDownload,
		isFetching: transientReducer?.isFetching,
		isFetchingPartner: userDetailsReducer?.isFetching,

	}
}
export default connect(mapStateToProps)(Ticket)

